import { Command } from '@ckeditor/ckeditor5-core';
import LinkModal from '../../link-modal';
export default class InsertRelatedExampleCommand extends Command {
    execute() {
        try {
            const publications = this.editor.config.get('internalLink.publications') || [];
            const linkModal = new LinkModal(this.filterByType(publications, ['resume-example', 'cover-letter-example']));
            linkModal
                .show()
                .then((exampleItem) => {
                this.editor.model.change((writer) => {
                    this.editor.model.insertContent(createRelatedExample(writer, exampleItem));
                });
            })
                .catch(() => { });
        }
        catch (error) {
            console.error(error);
        }
    }
    filterByType(publications, types) {
        return publications.filter(({ linkType }) => types.includes(linkType));
    }
    refresh() {
        this.isEnabled = true;
    }
}
function createRelatedExample(writer, exampleItem) {
    const { title, description, publicationId } = exampleItem;
    const relatedExample = writer.createElement('relatedExample', {
        exampleId: publicationId,
    });
    const titleElement = writer.createElement('relatedExampleTitle');
    const descriptionElement = writer.createElement('relatedExampleDescription');
    writer.appendText(title, titleElement);
    writer.appendText(description, descriptionElement);
    writer.append(titleElement, relatedExample);
    writer.append(descriptionElement, relatedExample);
    return relatedExample;
}
